import { GridColDef, GridRowId, GridValidRowModel } from '@mui/x-data-grid';
import React from 'react';
import ReactSwitch from 'react-switch';
import { GridApiCommunity } from '@mui/x-data-grid/internals';

interface RowVisibilitySwitcherColumnProps {
    setRows: (newRows: (oldRows: any[]) => any[]) => void;
    gridApiRef: React.MutableRefObject<GridApiCommunity>;
    getRowId(row: GridValidRowModel): any;
    columnHeader?: string;
    isDataTableView?: boolean;
}

const RowVisibilitySwitcherColumn = (
    props: RowVisibilitySwitcherColumnProps
): GridColDef => {
    const handleChange = (gridId: GridRowId, isVisible: boolean) => {
        const latestStateMap = props.gridApiRef.current.getRowModels();
        const latestStateArray = Array.from(latestStateMap.values());
        const updatedStateArray = latestStateArray.map((row) => {
            const updatedRow = { ...row, isVisible: isVisible };
            const id = props.getRowId(row);
            if (id === gridId) {
                return updatedRow;
            }
            return row;
        });

        props.setRows(() => updatedStateArray);
    };
    
    const column: GridColDef = {
        field: props.isDataTableView ? 'isIncluded' : 'isVisible',
        type: 'actions',
        headerName: props.columnHeader ? props.columnHeader : 'Visible',
        minWidth: 70,
        maxWidth: 100,
        headerAlign: 'left',
        cellClassName: 'switcher-cell item-visibility',
        getActions: (value: any) => {
            const id = value.id as number;

            return [
                <ReactSwitch
                    offColor="#d92550"
                    checked={value.row?.isVisible ?? false}
                    onChange={(event) => {
                        handleChange(id, event);
                    }}
                    height={22}
                />,
            ];
        },
    };

    return column;
};

export default RowVisibilitySwitcherColumn;
